import { buildBlogPath, buildShowPath } from "../lib/routes.js";
import { getAllBlogPosts, getBlogPostBySlug } from "../lib/blogPosts.js";
import { renderBlogAgeTable, renderBlogSources } from "../lib/blogRender.js";

function formatPublishDate(value) {
  return new Date(`${value}T12:00:00Z`).toLocaleDateString("en-US", {
    month: "long",
    day: "numeric",
    year: "numeric",
  });
}

function renderFaq(faq) {
  return `
    <section class="blog-post-faq">
      <p class="blog-section-kicker">Common questions</p>
      <h2 class="blog-section-title">People ask about this a lot.</h2>
      <div class="blog-faq-list">
        ${faq
          .map(
            (item) => `
          <article class="blog-faq-item">
            <h3>${item.question}</h3>
            <div>
              <p>${item.answer}</p>
            </div>
          </article>
        `,
          )
          .join("")}
      </div>
    </section>
  `;
}

export function BlogPostPage({ slug, store }) {
  const post = getBlogPostBySlug(slug);
  if (!post) {
    const element = document.createElement("section");
    element.className = "page-shell not-found-page";
    element.innerHTML = `
      <div class="not-found-inner">
        <p class="not-found-label">Missing post</p>
        <h1 class="not-found-title">That blog post is not here.</h1>
        <p class="not-found-desc">This article could not be found.</p>
        <a class="text-link" data-link href="${buildBlogPath()}">Back to blog</a>
      </div>
    `;
    return { title: "Missing blog post · HowOldHere", element };
  }

  const relatedShow = post.showId ? store?.getShowById(post.showId) : null;
  const showTagHtml = relatedShow
    ? `<a class="blog-post-show-tag" data-link href="${buildShowPath(relatedShow.id)}" aria-label="Open ${relatedShow.title} age page">${relatedShow.title} ages</a>`
    : "";

  const relatedPosts = getAllBlogPosts().filter(
    (candidate) => candidate.slug !== post.slug && post.relatedSlugs.includes(candidate.slug),
  );

  const element = document.createElement("section");
  element.className = "page-shell blog-post-page";
  element.innerHTML = `
    <div class="blog-post-inner">
      <header class="blog-post-hero">
        ${showTagHtml ? `<div class="blog-post-tags">${showTagHtml}</div>` : ""}
        <p class="blog-post-meta">${post.kicker} · Published <time datetime="${post.publishDate}">${formatPublishDate(post.publishDate)}</time> · Updated <time datetime="${post.seo.dateModified}">${formatPublishDate(post.seo.dateModified)}</time> · ${post.readingTime}</p>
        <h1 class="blog-post-title">${post.title}</h1>
        <p class="blog-post-summary">${post.summary}</p>
      </header>

      <article class="blog-post-prose">
        ${renderBlogAgeTable(post)}
        <p class="blog-source-note">${post.sourceNote}</p>
        ${post.bodyHtml}
        ${renderBlogSources(post)}
      </article>

      ${renderFaq(post.faq)}

      <section class="blog-related">
        <p class="blog-related-label">Keep reading</p>
        <div class="blog-related-grid">
          ${relatedPosts
            .map(
              (item) => `
            <a class="blog-related-card" data-link href="${buildBlogPath(item.slug)}">
              <h3>${item.title}</h3>
              <p>${item.teaser}</p>
            </a>
          `,
            )
            .join("")}
        </div>
      </section>
    </div>
  `;

  return {
    title: `${post.title} · HowOldHere`,
    element,
  };
}
